import React from "react";
import { Form } from "antd";
import { FormInstance } from "antd/lib/form/hooks/useForm";
import moment from "moment";
import { Nullable } from "../../../../../models/Common";
import { FleetCardAssignment } from "../../../../../models/FleetExpenses/FleetExpensesModel";
import FleetExpensesStore from "../../../../../stores/FleetExpensesStore";
import { OptionMap } from "../../../../../helpers/optionMap";
import { DRIVER_SELECT_PREFIX } from "../constants";
import { FleetExpenseFormValues } from "../types";
import CardAssignmentSelect from "./CardAssignmentSelect";

type CardAssignmentFormSectionProps = {
  drivers: Nullable<OptionMap<string>>;
  form: FormInstance<FleetExpenseFormValues>;
  onAssignmentsChange: (assignments: Nullable<FleetCardAssignment[]>) => void;
  onLoadingChange: (isLoading: boolean) => void;
  refreshKey: number;
  store: typeof FleetExpensesStore;
};

const CardAssignmentFormSection = ({
  drivers,
  form,
  onAssignmentsChange,
  onLoadingChange,
  refreshKey,
  store,
}: CardAssignmentFormSectionProps): React.ReactElement => (
  <Form.Item<FleetExpenseFormValues>
    key={refreshKey}
    shouldUpdate={(previousValues, currentValues) =>
      previousValues.driver_id !== currentValues.driver_id ||
      previousValues.date !== currentValues.date
    }
  >
    {({ getFieldValue }) => {
      const selectedDriverValue: unknown = getFieldValue("driver_id");
      const driverKey =
        typeof selectedDriverValue === "string" && drivers
          ? drivers.parsePrefix(selectedDriverValue, DRIVER_SELECT_PREFIX)
          : null;
      let driverId: Nullable<number> = null;
      if (driverKey !== null && driverKey !== undefined) {
        const parsedDriverId = Number(driverKey);
        if (Number.isSafeInteger(parsedDriverId)) {
          driverId = parsedDriverId;
        }
      }

      const selectedDateValue: unknown = getFieldValue("date");
      const date = moment.isMoment(selectedDateValue)
        ? selectedDateValue.format("YYYY-MM-DD")
        : null;

      return (
        <CardAssignmentSelect
          date={date}
          driverId={driverId}
          form={form}
          onAssignmentsChange={onAssignmentsChange}
          onLoadingChange={onLoadingChange}
          refreshKey={refreshKey}
          store={store}
        />
      );
    }}
  </Form.Item>
);

export default CardAssignmentFormSection;
